module.exports = {"libs.subscriptionActivate.message.required":"Erforderlich","libs.subscriptionActivate.message.invalidPassword":"Ihr Passwort muss 8 Zeichen lang sein. Bitte aktualisieren."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/libs/subscriptionActivate.json
// module id = 876
// module chunks = 0